import RawWsService from "../RawWsService";
import Customer from "../../domain/Customer/Customer";
import RegistrationCreationRequest from "../../domain/Registration/RegistrationCreationRequest";
import BasicAuthGenerator from "../../utils/BasicAuthGenerator";
import UserSessionService from "../UserSessionService";

const ENDPOINT_BASE = "/registrations/registration/";

export default class RegistrationService {

    static createRegistration(registrationCreationRequest, referralCode) {

        let jsonObj = RegistrationCreationRequest.toJson(registrationCreationRequest);

        let registrationHeaders = UserSessionService.retrieveRegisteringHeaders();

        let headers = {
            "Authorization": BasicAuthGenerator.create(registrationHeaders["registering-partner-username"], registrationHeaders["registering-partner-password"]),
            'registering-partner-id': registrationHeaders["registering-partner-id"],
            'registering-channel-id': registrationHeaders["registering-channel-id"],
            'referral-code': referralCode ? referralCode : ""
        };

        return RawWsService.postWithHeaders(ENDPOINT_BASE, jsonObj, 201, headers).then(
            response => {
                return new Customer(response.body);
            },
            response => {
                return response;
            });
    }
}